import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { getCurrentHub } from '@sentry/core';
import { isInternal } from './isInternal.js';

/**
 * Checks is `targetHost` is a Sentry ingestion host
 */
function isIngestHost(targetHost) {
  const { protocol, host } = _optionalChain([getCurrentHub, 'call', _ => _(), 'access', _2 => _2.getClient, 'call', _3 => _3(), 'optionalAccess', _4 => _4.getDsn, 'call', _5 => _5()]) || {};

  // XXX: Special case when this integration is used by Sentry on `sentry.io`
  // We would like to capture network requests made to our ingest endpoints for debugging
  if (isInternal()) {
    return false;
  }

  return targetHost.startsWith(`${protocol}://${host}`);
}

export { isIngestHost };
//# sourceMappingURL=isIngestHost.js.map
